import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface CustomFieldValueDocument extends BaseDocument {
  taskId: string
  customFieldDefinitionId: string
  stringValue: string | null
  numberValue: number | null
  dateValue: number | null
}

const hooks = createEntityHooks<CustomFieldValueDocument>('customfieldvalues')

export const useCustomFieldValues = (filter?: Partial<CustomFieldValueDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { customFieldValues: data, isLoading, db }
}

export const useCustomFieldValue = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { customFieldValue: data, isLoading }
}

export const useCustomFieldValueMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createCustomFieldValue: create,
    updateCustomFieldValue: update,
    deleteCustomFieldValue: deleteEntity,
  }
}
